import { lazy } from 'react';

import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';

const NotificationsCenter = Loadable(lazy(() => import('pages/notificaciones')));

const NotificationsRoutes = {
  path: '/notificaciones',
  element: (
    <ProtectedRoute>
      <NotificationsCenter />
    </ProtectedRoute>
  )
};

export default NotificationsRoutes;
